import { render } from "./EarLobeRepairContentPtBR.vue?vue&type=template&id=77849772&scoped=true"
import script from "./EarLobeRepairContentPtBR.vue?vue&type=script&lang=js"
export * from "./EarLobeRepairContentPtBR.vue?vue&type=script&lang=js"

import "./EarLobeRepairContentPtBR.vue?vue&type=style&index=0&id=77849772&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77849772"]])

export default __exports__